import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'lookupMulti' })
export class LookupMultiPipe implements PipeTransform {
  /**
   * Finds the first item in a list where all provided criteria pairs match.
   *
   * Usage:
   *   items | lookupMulti : { field1: value1, field2: value2 }
   *
   * Example:
   *   thresholds | lookupMulti:{ status: 'LATE', role: 'Organizer' }
   */
  transform<T extends Record<string, unknown>>(
    items: readonly T[] | null | undefined,
    criteria: Partial<T> | null | undefined,
  ): T | undefined {
    if (!criteria || Object.keys(criteria).length === 0) {
      return undefined;
    }

    return items?.find((item) =>
      Object.entries(criteria).every(([key, value]) => {
        const itemValue = item[key];
        return typeof itemValue === 'string' && typeof value === 'string'
          ? itemValue.toLowerCase() === value.toLowerCase()
          : itemValue === value;
      }),
    );
  }
}
